BookingsEditDeleteController.$inject = ['$scope', 'alerts', 'Time', '_', 'User'];

/* @ngInject */
function BookingsEditDeleteController($scope, alerts, Time, _, User) {
    var vm = this;

    var $parent = $scope.$parent.vm;

    var since = Time.moment($parent.getDate()).add(6, 'days').startOf('day');
    var booking = $parent.booking;

    var event_date = Time.moment($parent.getDate()).startOf('day');
    var current_date = event_date.clone().add(1, 'week');
    vm.first_date = current_date.clone();

    vm.cancel_no_code=false;

    vm.loading = false;
    vm.reason = 0;
    vm.reasonTxt = '';
    vm.reasons = {
        1: 'Llamó para cancelar',
        2: 'No vino',
        3: 'Reserva incorrecta',
        4: 'Datos mal cargados',
        5: 'Cancela por lluvia',
        'more': 'Otro'
    };
    vm.definitive = false;
    vm.same_weeks = false;

    var end_date = null;

    if (booking.attrs.fixed) {
        var booking_end = booking.getEndDate();
        if (booking_end) {
            var weeks = booking_end.diff(since, 'weeks') + 1;
            end_date = event_date.clone().add(weeks, 'weeks');

            vm.show_text = {
                weeks: weeks,
                last_date: end_date.format('DD-MM-YYYY')
            };

            vm.end_date = {
                date: booking.getEndDate().toDate(),
                show: true,
                open: false,
                options: {
                    minDate: since.clone().toDate(),
                    showWeeks: false
                }
            };
        }
    }

    vm.since_date = {
        date: since.clone().toDate(),
        show: true,
        open: false,
        options: {
            minDate: since.clone().toDate(),
            maxDate: end_date ? end_date.clone().subtract(1, 'day').toDate() : '',
            showWeeks: false
        }
    };

    vm.booking_code = '';
    vm.booking_code_tmp = '';
    vm.hasPayment = booking.hasPayment();

    vm.cancel = function () {
        alerts
            .verifyCode('Cancelar Reserva', null, User)
            .then(cancel)
            .catch((error) => {
                alerts.errorHandler(error);
            });
    };
    

    vm.calcuteEndDate = function () {
        var weeks = booking.getWeeksToPlay();

        var aux = vm.first_date.clone().add(weeks - 1, 'weeks');

        vm.end_date.date = aux.toDate();
        vm.show_text.weeks = weeks;
        vm.show_text.last_date = aux.format('DD-MM-YYYY');
    }

    vm.sinceDateUpdated = function () {
        var since_date = moment(vm.since_date.date).startOf('day');
        var diff = since_date.diff(event_date, 'weeks') + 1;
        vm.first_date = event_date.clone().add(diff, 'weeks');

        if (vm.end_date && vm.end_date.date) {
            var end_date = moment(vm.end_date.date).startOf('day');

            var weeks = end_date.diff(since_date, 'weeks') + 1;

            vm.show_text.weeks = weeks;

            vm.end_date.options.minDate = vm.first_date.clone().subtract('day').toDate();

            if (vm.same_weeks) {
                vm.calcuteEndDate();
            }
        }


    }

    vm.endDateUpdated = function () {
        var since_date = moment(vm.since_date.date).startOf('day');
        var end_date = moment(vm.end_date.date).startOf('day');

        var weeks = end_date.diff(since_date, 'weeks');

        var last_date = vm.first_date.clone().add(weeks, 'weeks');

        vm.show_text.weeks = weeks;
        vm.show_text.last_date = last_date.format('DD-MM-YYYY')
        vm.since_date.options.maxDate = last_date.clone().subtract(1, 'day').toDate();
    }

    vm.can_use_balance = function () {
        if (!vm.definitive &&
            _.includes(['1', '2', 'more'], vm.reason) &&
            booking.attrs.balance > 0) {
            return true;
        }
        return false;
    };
    vm.use_balance = false;

    $scope.$watch('delete.since_date.show', function (newValue) {
        if (newValue) {
            vm.since_date.date = since.clone().toDate();
        } else {
            vm.since_date.date = null;
        }
    });

    vm.cancelNoCodeClick = function(ev){
        if(ev){
            vm.booking_code_tmp=vm.booking_code;
            vm.booking_code='';
        }else{
            vm.booking_code=vm.booking_code_tmp;
        }
    }

    function cancel_formatData(code) {
        var data = {
            code: code,
            date: $parent.getDate(),
            definitive: vm.definitive ? 1 : 0,
            use_balance: vm.use_balance ? 1 : 0,
            cancel_no_code: vm.cancel_no_code ? 1 : 0,
        };

        if (booking.isFixed() && !vm.definitive) {
            data.since = Time.moment(vm.since_date.date).format('Y-MM-DD');
            if (vm.end_date && vm.end_date.date) {
                data.end = Time.moment(vm.end_date.date).format('Y-MM-DD');
            }
        }

        if (booking.isFixed() && vm.definitive) {
            data.use_balance = 1;
        }

        if (vm.reason === 'more') {
            data.reason = vm.reasonTxt;
        } else {
            data.reason = vm.reasons[vm.reason];
            if (_.includes(['3', '4'], vm.reason)) {
                data.annul = 1;
            }
        }

        if (!booking.isFixed()) {
            delete data.definitive;
        }

        if (booking.isOnline()) {
            data.booking_code = vm.booking_code;
        }

        return data;
    }


    function cancel({code}) {
        var data = cancel_formatData(code);

        vm.loading = true;

        $parent.booking.api()
            .customDELETE(null, data)
            .then(function (data) {
                if(vm.cancel_no_code){
                    window.open(data.link, '_blank');
                }
                alerts.success('¡Exito!', 'Se canceló la reserva correctamente');
                $parent.remove(true);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }


    vm.report = {
        can: booking.canReport(),
        fire: function () {
            alerts
                .confirm('¿Estás seguro que deseas reportar al jugador?',
                    'Se le aplicará una penalización al jugador que reservó y no se presentó, por lo que es importante que sea ese el motivo del reporte.')
                // .then(alerts.code)
                .then(alerts.code(null,null,User).then(function(res){
                    report(res);
                }))
                // .then(report)
                ;
        }
    };

    /**
     * @method report
     * @param  {string} code
     */
    function report(code) {
        var data = {
            code: code
        };
        vm.loading = true;

        $parent.booking.api()
            .customDELETE('report', data)
            .then(function () {
                alerts.success('¡Exito!', 'La reserva se reportó exitosamente');
                $parent.remove(true);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    };

}

export default BookingsEditDeleteController;
